import { render, staticRenderFns } from "./PromotionCustomerGroup.vue?vue&type=template&id=36f334d5&"
import script from "./PromotionCustomerGroup.vue?vue&type=script&lang=ts&"
export * from "./PromotionCustomerGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports